import type { NavItem } from '@frontend/nav-primitives';
import { NOT_SUPPORTED_IN_SCOPE_MESSAGE, useScopePolicy } from '@frontend/scope-access';
import { useAnalyticsNavItem } from './analytics/use-analytics-nav-item';
import { useCallsNavItem } from './calls/use-calls-nav-item';
import { useContactsNavItem } from './contacts/use-contacts-nav-item';
import { useFaxNavItem } from './fax/use-fax-nav-item';
import { useFormsNavItem } from './forms/use-forms-nav-item';
import { useHomeNavItem } from './home/use-home-nav-item';
import { useMarketingNavItem } from './marketing/use-marketing-nav-item';
import { useMessagesNavItem } from './messages/use-messages-nav-item';
import { usePaymentsNavItem } from './payments/use-payments-nav-item';
import { useReviewsNavItem } from './reviews/use-reviews-nav-item';
import { useScheduleNavItem } from './schedule/use-schedule-nav-item';

export const usePrimaryNavContent = () => {
  const { getDecisionForPath } = useScopePolicy();
  const home = useHomeNavItem();
  const messages = useMessagesNavItem();
  const calls = useCallsNavItem();
  const schedule = useScheduleNavItem();
  const payments = usePaymentsNavItem();
  const forms = useFormsNavItem();
  const fax = useFaxNavItem();
  const contacts = useContactsNavItem();
  const reviews = useReviewsNavItem();
  const analytics = useAnalyticsNavItem();
  const marketing = useMarketingNavItem();

  const applyWorkspaceVisibility = (item: NavItem): NavItem => {
    const isAlreadyHidden = item.show === false;

    if (isAlreadyHidden) {
      return item;
    }

    const decision = getDecisionForPath(item.root);
    const isBlockedByScope = decision.availability !== 'available';

    return {
      ...item,
      disabledReason: isBlockedByScope ? NOT_SUPPORTED_IN_SCOPE_MESSAGE : undefined,
    };
  };

  const navItems = [
    home,
    messages,
    calls,
    schedule,
    payments,
    forms,
    fax,
    contacts,
    reviews,
    analytics,
    marketing,
  ] as const satisfies NavItem[];

  return navItems.map(applyWorkspaceVisibility);
};
